export const AUTH_ACTIONS = {
  SET_CHECKED: 'AUTH_ACTIONS/SET_CHECKED',
  SET_USER: 'AUTH_ACTIONS/SET_USER',
  SIGNOUT: 'AUTH_ACTIONS/SIGNOUT',
}
